module.exports = __webpack_public_path__ + "img/help-subscribe.d9615c06.png";